<template>
  <div class="shoppe">
    <p>请输入不制作关键词，一行一个。搜索请通过浏览器页面搜索（Ctrl+F）功能进行查找</p>
    <el-button class="mt20" @click="submit" type="primary">提交</el-button>
    <div class="mt20 wrap">
      <el-input type="textarea" :rows="25" v-model="textarea"></el-input>
    </div>
  </div>
</template>

<script>
import {
  getIncompleteProductKeyword,
  submitIncompleteProductKeyword,
} from './api'

export default {
  data() {
    return {
      loading: false,
      textarea: '',
    };
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      getIncompleteProductKeyword().then(res => {
        this.textarea = res.data.join('\n');
      })
    },
    async submit() {
      let categoryKeywordList = this.textarea.split('\n').filter(item => item.trim());
      if (categoryKeywordList.length === 0) {
        this.$message('请输入关键词');
        return;
      }
      const result = await this.$confirm('是否确认提交？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      });
      if (!result) {
        return;
      }
      categoryKeywordList = [...new Set(categoryKeywordList)];
      if (this.repeatSubmit) {
        return;
      }
      this.repeatSubmit = true;
      submitIncompleteProductKeyword({ categoryKeywordList }).then(res => {
        if (res.success) {
          this.$message('任务已提交，请在任务管理中查看执行结果');
          this.getDetail();
        } else {
          this.$message(res.message || '系统异常，请稍后再试');
        }
        setTimeout(() => {
          this.repeatSubmit = false;
        }, 1000);
      })
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  height: 100%;
  padding: 20px;
}
.mt20 {
  margin-top: 20px;
}
.wrap {
  width: 500px;
}
</style>
